(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a2d-hover-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isTouchDevice() {
    return window.matchMedia('(max-width: 640px)').matches;
  }
  function initA2DTiles() {
    var tiles = document.querySelectorAll('.a2d-tiles-section .a2d-tile');
    if (!tiles.length) return;
    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (!isTouchDevice()) return;
        var isOpen = tile.classList.contains('is-open');
        tiles.forEach(function (t) { t.classList.remove('is-open'); });
        if (!isOpen) {
          tile.classList.add('is-open');
        }
        if (e.target.tagName === 'A') return;
        if (!isOpen) {
          e.preventDefault();
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initA2DTiles);
  } else {
    initA2DTiles();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a2d-mega-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.a2dMmInit) return;
    root.dataset.a2dMmInit = '1';

    var drawer  = root.querySelector('[data-a2d-mm-drawer]');
    var overlay = root.querySelector('[data-a2d-mm-overlay]');
    var openBtn = root.querySelector('[data-a2d-mm-open]');
    var closeBtn = root.querySelector('[data-a2d-mm-close]');
    var backBtn = root.querySelector('[data-a2d-mm-back]');
    var titleEl = root.querySelector('[data-a2d-mm-title]');
    if (!drawer || !overlay || !openBtn) return;

    var viewStack = ['root'];

    function showView(viewName, title) {
      var lists = drawer.querySelectorAll('.a2d-mm__drawer-list');
      lists.forEach(function (l) {
        var match = l.dataset.view === viewName;
        l.classList.toggle('is-active', match);
        if (match) {
          l.hidden = false;
          l.scrollTop = 0;
        } else {
          l.hidden = true;
        }
      });
      if (title && titleEl) titleEl.textContent = title;
      if (backBtn) backBtn.hidden = viewStack.length <= 1;
    }

    function openDrawer() {
      viewStack = ['root'];
      showView('root', 'Shop by Machine');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      document.body.classList.add('a2d-mm-locked');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.hidden = true; }, 240);
      document.body.classList.remove('a2d-mm-locked');
    }

    function goBack() {
      if (viewStack.length <= 1) return;
      viewStack.pop();
      var prev = viewStack[viewStack.length - 1];
      var title;
      if (prev === 'root') {
        title = 'Shop by Machine';
      } else {
        var sourceBtn = drawer.querySelector('[data-drill="' + prev + '"]');
        title = sourceBtn ? sourceBtn.dataset.drillTitle || 'Shop by Machine' : 'Shop by Machine';
      }
      showView(prev, title);
    }

    function drillInto(target, title) {
      viewStack.push(target);
      showView(target, title);
    }

    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backBtn) backBtn.addEventListener('click', goBack);
    overlay.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drill]');
      if (!btn) return;
      drillInto(btn.dataset.drill, btn.dataset.drillTitle || '');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Toggle aria-expanded on desktop brand pills (for keyboard users)
    root.querySelectorAll('.a2d-mm__brand--has-panel').forEach(function (li) {
      var pill = li.querySelector('.a2d-mm__pill');
      if (!pill) return;
      li.addEventListener('mouseenter', function () { pill.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { pill.setAttribute('aria-expanded', 'false'); });
      li.addEventListener('focusin', function () { pill.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) pill.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-a2d-mm]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  // Re-init for Shopify section rendering API (theme editor)
  document.addEventListener('shopify:section:load', bootstrap);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  /* ============================================================
   A2D CURATED FILTER PRESENTATION LAYER
   Injected: 2026-05-08  |  Rewritten: 2026-05-10
   Target: shopify mega menu project theme (158342906101)
   Purpose: Curated filter display — only approved brands and
            model families are visible. Brand-scoped model
            filtering ensures selecting Polaris shows only
            Polaris models. Dirty/compound/ATV values hidden.
            Renames "ATV/UTV Subcategory Test" to "Parts Filter".
            Progressive disclosure: hides non-brand filters
            until a brand is selected.
            Brand order: Polaris, Can-Am, Yamaha, Honda first.
   Scope: UI-only — NO data deletion, NO metafield changes.
   Rollback: Remove this entire script block.
   ============================================================ */
(function(){
  'use strict';

  /* ============================================================
     CURATED MODEL MAP — Source: MACHINE_CANONICAL_MAP.json
     Only these values are allowed in the filter UI.
     ============================================================ */
  var CURATED_MODELS = {
    'Polaris':   ['RZR','Ranger','General','Xpedition'],
    'Can-Am':    ['Defender','Maverick','Maverick X3','Maverick R','Maverick Sport','Maverick Trail','Commander'],
    'Honda':     ['Talon','Pioneer'],
    'Yamaha':    ['Wolverine','Viking'],
    'Kawasaki':  ['Teryx','Teryx KRX','KRX']
  };

  var isSnowmobile = window.location.pathname.split('/').indexOf('snowmobile') !== -1;
  /* 2026-09-23: snow families/submodels widened to the values the Len Performance and Zbroz shock listings carry. */
  if(isSnowmobile){CURATED_MODELS={'Polaris':['Matryx','AXYS','Pro-Ride'],'Ski-Doo':['Gen4','Gen5','REV-XS','REV-XM','REV-XU'],'Lynx':['Radien','Radien2'],'Arctic Cat':['Ascender','Catalyst','ProCross','ProClimb','Alpha One']};}
  /* Build fast lookup maps */
  var APPROVED_BRANDS = {};
  Object.keys(CURATED_MODELS).forEach(function(b){
    APPROVED_BRANDS[b.toLowerCase()] = b;
  });

  var ALL_FAMILIES = {};
  Object.keys(CURATED_MODELS).forEach(function(b){
    CURATED_MODELS[b].forEach(function(m){
      ALL_FAMILIES[m.toLowerCase()] = true;
    });
  });

  var BRAND_FAMILIES = {};
  Object.keys(CURATED_MODELS).forEach(function(b){
    var set = {};
    CURATED_MODELS[b].forEach(function(m){ set[m.toLowerCase()] = true; });
    BRAND_FAMILIES[b] = set;
  });

  /* ============================================================
     CURATED SUBMODEL MAP — Source: CANONICAL_MODELS_SUBMODELS.json
     Brand → Model Family → allowed submodel values.
     Used to filter Machine Submodel sidebar by selected brand/family.
     ============================================================ */
  var CURATED_SUBMODELS = {
    'Polaris': {
      'RZR': ['570','800','900','Pro R','Pro S','Pro XP','RS1','S 900','S 1000','Trail','Trail 900','Trail S 900','Trail S 1000','Turbo R','Turbo S','XP 570','XP 900','XP 1000','XP Turbo','XP Turbo S'],
      'Ranger': ['570','800','900','1000','1000 Crew','SP 570','XP 570','XP 800','XP 900','XP 1000','XP 1000 Crew','Crew XP 1500','XD','XD 1500','XD 1500 Expedition','Mid-Size','Full-Size','Highlifter','Northstar'],
      'General': ['1000','XP 1000'],
      /* 2026-09-24: exact fitment.machine_submodel values used on Xpedition products (windshields, clutch kit, spring kits). */
      'Xpedition': ['ADV','ADV 5','XP','XP 5']
    },
    'Can-Am': {
      'Maverick X3': ['DS','RS','RC','Turbo','Turbo R','Turbo RR','XMR','XMR Turbo R'],
      'Maverick': [],
      /* 2026-09-23: exact fitment.machine_submodel values used on Defender products. MAX HD*, Limited,
         X mr, 6x6 and 6x6 Limited were missing, so the sidebar hid them and the 2" rear offset arms
         (tagged Limited / X mr / 6x6 Limited) could not be reached from the filter. */
      'Defender': ['HD5','HD7','HD8','HD9','HD10','HD11','MAX HD7','MAX HD8','MAX HD9','MAX HD10','MAX HD11','Limited','X mr','6x6','6x6 Limited'],
      'Commander': []
    },
    'Honda': {
      'Talon': ['1000R','1000X','1000R 4','1000X 4'],
      'Pioneer': ['500','520','700','700-4','1000','1000-5']
    },
    'Kawasaki': {
      'Teryx': ['800','Teryx 4'],
      'KRX': ['KRX 1000']
    },
    'Yamaha': {
      'Wolverine': ['X2 850','X4 850','X2 1000','RMAX2 1000','RMAX4 1000'],
      'Viking': ['700']
    }
  };

  if(isSnowmobile){var SNOW_POL=['RMK','Pro RMK','Khaos','SKS','Switchback','Indy','Rush','650','850 Patriot','9R','Patriot Boost'];var SNOW_SD=['Summit','Freeride','MXZ','Renegade','Backcountry','Expedition','600R','850','850 Turbo'];var SNOW_AC=['M-Series','Mountain Cat','ZR','XF','Riot','Pantera','800','858'];var SNOW_LYNX=['Shredder','BoonDocker','Xterrain','Ranger'];CURATED_SUBMODELS={'Polaris':{'Matryx':SNOW_POL,'AXYS':SNOW_POL,'Pro-Ride':SNOW_POL},'Ski-Doo':{'Gen4':SNOW_SD,'Gen5':SNOW_SD,'REV-XS':SNOW_SD,'REV-XM':SNOW_SD,'REV-XU':SNOW_SD},'Lynx':{'Radien':SNOW_LYNX,'Radien2':SNOW_LYNX},'Arctic Cat':{'Ascender':SNOW_AC,'Catalyst':SNOW_AC,'ProCross':SNOW_AC,'ProClimb':SNOW_AC,'Alpha One':SNOW_AC}};}
  /* Build allowed-submodel sets per brand and per brand+family */
  var BRAND_SUBMODELS = {};
  Object.keys(CURATED_SUBMODELS).forEach(function(brand){
    var set = {};
    var families = CURATED_SUBMODELS[brand];
    Object.keys(families).forEach(function(fam){
      families[fam].forEach(function(sub){ set[sub.toLowerCase()] = true; });
    });
    BRAND_SUBMODELS[brand] = set;
  });

  var FAMILY_SUBMODELS = {};
  Object.keys(CURATED_SUBMODELS).forEach(function(brand){
    var families = CURATED_SUBMODELS[brand];
    Object.keys(families).forEach(function(fam){
      var key = brand.toLowerCase() + '|' + fam.toLowerCase();
      var set = {};
      families[fam].forEach(function(sub){ set[sub.toLowerCase()] = true; });
      FAMILY_SUBMODELS[key] = set;
    });
  });

  /* ============================================================
     TIRES & WHEELS COLLECTION — SPECIAL HANDLING
     On /collections/tires-and-wheels:
     - Hide Machine Brand filter (no fitment on tires/wheels)
     - Show custom Brand filter (vendor-based)
     - Skip progressive disclosure (show Parts Filter immediately)
     - Default sort: price-descending
     ============================================================ */
  var TIRE_WHEEL_BRANDS = ['System 3','Sedona','ITP','Maxxis','Raceline','SuperATV'];

  function isTiresWheelsCollection(){
    return window.location.pathname.indexOf('/collections/tires-and-wheels') !== -1;
  }

  /* ---- Get selected vendor(s) from URL ---- */
  function getSelectedVendors(){
    var params = new URLSearchParams(window.location.search);
    return params.getAll('filter.p.vendor');
  }

  /* ---- Get selected tag(s) from URL ---- */
  function getSelectedTags(){
    var params = new URLSearchParams(window.location.search);
    return params.getAll('filter.p.tag');
  }

  /* ---- Get selected brand(s) from URL ---- */
  function getSelectedBrands(){
    var params = new URLSearchParams(window.location.search);
    var vals = params.getAll('filter.p.m.fitment.machine_brand');
    return vals.map(function(v){ return v.trim(); }).filter(function(v){ return v; });
  }

  /* ---- Get selected model family(ies) from URL ---- */
  function getSelectedModelFamilies(){
    var params = new URLSearchParams(window.location.search);
    var vals = params.getAll('filter.p.m.fitment.machine_model_family');
    return vals.map(function(v){ return v.trim(); }).filter(function(v){ return v; });
  }

  /* ---- Check if a value is dirty/compound ---- */
  function isDirty(text){
    if (!text) return false;
    if (text.indexOf(',') !== -1) return true;
    if (text.indexOf('|') !== -1) return true;
    return false;
  }

  /* ---- Extract clean text from a filter <li> ---- */
  function getFilterText(li){
    var clone = li.cloneNode(true);
    var counts = clone.querySelectorAll('.count, .facets__count, [class*="count"]');
    counts.forEach(function(c){ c.remove(); });
    var text = (clone.textContent || '').trim();
    return text.replace(/\s*\(\d+\)\s*$/,'').trim();
  }

  /* ---- Identify filter group type by inspecting contents ---- */
  function identifyGroup(details){
    var html = details.innerHTML || '';
    if (html.indexOf('machine_brand') !== -1) return 'brand';
    if (html.indexOf('machine_model_family') !== -1) return 'model_family';
    if (html.indexOf('machine_submodel') !== -1) return 'submodel';
    if (html.indexOf('atv_utv_subcategory_test') !== -1) return 'subcategory';
    if (html.indexOf('atv_utv_category') !== -1) return 'category';
    if (html.indexOf('year_range') !== -1) return 'year';
    var summary = details.querySelector('summary');
    if (summary){
      var t = (summary.textContent || '').toLowerCase();
      if (t.indexOf('machine brand') !== -1) return 'brand';
      if (t.indexOf('model family') !== -1) return 'model_family';
      if (t.indexOf('submodel') !== -1) return 'submodel';
      if (t.indexOf('subcategory') !== -1 || t.indexOf('parts filter') !== -1) return 'subcategory';
      if (t.indexOf('category') !== -1) return 'category';
    }
    return 'other';
  }

  /* ---- Hide or show a filter <li> ---- */
  function hide(li, reason){
    li.style.display = 'none';
    li.setAttribute('data-a2d-curated', reason);
  }
  function show(li){
    li.style.display = '';
    li.removeAttribute('data-a2d-curated');
  }

  /* ============================================================
     MAIN CURATION FUNCTION
     ============================================================ */
  function curateAllFilters(){
    var selectedBrands = getSelectedBrands();

    /* Build allowed model family set based on selected brand(s) */
    var allowedFamilies = null;
    if (selectedBrands.length > 0){
      allowedFamilies = {};
      selectedBrands.forEach(function(brand){
        var fams = BRAND_FAMILIES[brand];
        if (fams){
          Object.keys(fams).forEach(function(f){ allowedFamilies[f] = true; });
        }
      });
    }

    /* Find all filter groups */
    var groups = document.querySelectorAll(
      '.collection-wrapper details, results-list details, .facets-container details'
    );

    groups.forEach(function(group){
      var type = identifyGroup(group);
      var items = group.querySelectorAll('li');

      if (type === 'brand'){
        /* ---- BRAND FILTER: whitelist only ---- */
        items.forEach(function(li){
          var text = getFilterText(li);
          if (!text) return;
          var lower = text.toLowerCase();
          if (isDirty(text) || !APPROVED_BRANDS[lower]){
            hide(li, 'brand-blocked');
          } else {
            show(li);
          }
        });
      }
      else if (type === 'model_family'){
        /* ---- MODEL FAMILY FILTER: brand-scoped whitelist ---- */
        items.forEach(function(li){
          var text = getFilterText(li);
          if (!text) return;
          var lower = text.toLowerCase();

          /* Always hide dirty compound values */
          if (isDirty(text)){
            hide(li, 'dirty');
            return;
          }

          if (allowedFamilies){
            /* Brand IS selected — show ONLY that brand's models */
            if (allowedFamilies[lower]){
              show(li);
            } else {
              hide(li, 'wrong-brand');
            }
          } else {
            /* No brand selected — show all approved families */
            if (ALL_FAMILIES[lower]){
              show(li);
            } else {
              hide(li, 'unapproved');
            }
          }
        });
      }
      else if (type === 'submodel'){
        /* ---- SUBMODEL FILTER: brand+family-scoped whitelist ---- */
        var selectedFamilies = getSelectedModelFamilies();

        items.forEach(function(li){
          var text = getFilterText(li);
          if (!text) return;
          var lower = text.toLowerCase();

          /* Always hide dirty compound values */
          if (isDirty(text)){
            hide(li, 'dirty');
            return;
          }

          if (selectedBrands.length === 0){
            /* No brand selected — show all known submodels */
            var knownSub = false;
            Object.keys(BRAND_SUBMODELS).forEach(function(b){
              if (BRAND_SUBMODELS[b][lower]) knownSub = true;
            });
            if (knownSub){ show(li); } else { hide(li, 'unknown-submodel'); }
            return;
          }

          if (selectedFamilies.length > 0){
            /* Brand AND family selected — show only that combo's submodels */
            var allowed = false;
            selectedBrands.forEach(function(brand){
              selectedFamilies.forEach(function(fam){
                var key = brand.toLowerCase() + '|' + fam.toLowerCase();
                if (FAMILY_SUBMODELS[key] && FAMILY_SUBMODELS[key][lower]){
                  allowed = true;
                }
              });
            });
            if (allowed){ show(li); } else { hide(li, 'wrong-family'); }
          } else {
            /* Brand selected but no family — show all submodels for that brand */
            var brandAllowed = false;
            selectedBrands.forEach(function(brand){
              if (BRAND_SUBMODELS[brand] && BRAND_SUBMODELS[brand][lower]){
                brandAllowed = true;
              }
            });
            if (brandAllowed){ show(li); } else { hide(li, 'wrong-brand'); }
          }
        });
      }
      else if (type === 'subcategory'){
        /* ---- RENAME "ATV/UTV Subcategory Test" to "Parts Filter" ---- */
        renameLabel(group, 'Parts Filter');
      }
    });
  }

  /* ============================================================
     A2D: ENSURE CURATED SUBMODELS EXIST IN THE FACET — 2026-09-23
     Shopify caps the values it lists for a filter, and the rarer
     Defender values (Limited, X mr, 6x6, 6x6 Limited) fall off the
     list, so their checkboxes never render even though products
     carry them. When exactly one brand + one family is selected,
     clone an existing submodel <li> for every curated value that is
     missing. The clone sits inside the facets form, so the theme's
     FormData-based filter update picks it up like a native value.
     ============================================================ */
  function ensureSubmodels(){
    var brands = getSelectedBrands();
    var fams = getSelectedModelFamilies();
    if (brands.length !== 1 || fams.length !== 1) return;
    var key = brands[0].toLowerCase() + '|' + fams[0].toLowerCase();
    /* Only families whose curated values are all verified to exist on products. */
    var INJECT_FAMILIES = { 'can-am|defender': true };
    if (!INJECT_FAMILIES[key]) return;
    var curated = null;
    Object.keys(CURATED_SUBMODELS).forEach(function(b){
      Object.keys(CURATED_SUBMODELS[b]).forEach(function(f){
        if ((b.toLowerCase() + '|' + f.toLowerCase()) === key) curated = CURATED_SUBMODELS[b][f];
      });
    });
    if (!curated || !curated.length) return;
    var activeSubs = new URLSearchParams(window.location.search).getAll('filter.p.m.fitment.machine_submodel');

    var groups = document.querySelectorAll('.collection-wrapper details, results-list details, .facets-container details');
    groups.forEach(function(group){
      if (identifyGroup(group) !== 'submodel') return;
      var inputs = group.querySelectorAll('input[name="filter.p.m.fitment.machine_submodel"]');
      if (!inputs.length) return;
      var have = {};
      inputs.forEach(function(inp){ have[(inp.value || '').toLowerCase()] = true; });
      var templateLi = inputs[0].closest('li');
      var list = templateLi && templateLi.parentNode;
      if (!templateLi || !list) return;

      curated.forEach(function(val){
        if (have[val.toLowerCase()]) return;
        var li = templateLi.cloneNode(true);
        li.setAttribute('data-a2d-injected', 'true');
        li.classList.remove('hidden');
        li.style.display = '';
        var inp = li.querySelector('input');
        var lab = li.querySelector('label');
        if (!inp) return;
        var id = 'Filter-a2d-sub-' + val.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
        inp.value = val;
        inp.id = id;
        inp.setAttribute('data-label', val);
        inp.checked = activeSubs.indexOf(val) !== -1;
        if (lab){
          lab.setAttribute('for', id);
          var txt = lab.querySelector('.checkbox__label-text');
          if (txt) txt.textContent = val; else lab.textContent = val;
        }
        var cnt = li.querySelector('.count, .facets__count, [class*="count"]');
        if (cnt) cnt.remove();
        list.appendChild(li);
        have[val.toLowerCase()] = true;
      });
    });
  }

  /* ---- Rename a filter group's summary label ---- */
  function renameLabel(group, newName){
    var summary = group.querySelector('summary');
    if (!summary) return;
    var targets = summary.querySelectorAll(
      'span, .filter-group-display__name, .facets__heading-text'
    );
    var renamed = false;
    targets.forEach(function(el){
      var t = el.textContent || '';
      if (t.indexOf('ubcategory') !== -1 || t.indexOf('ATV/UTV') !== -1){
        el.textContent = newName;
        renamed = true;
      }
    });
    if (!renamed){
      /* Walk text nodes */
      var walker = document.createTreeWalker(summary, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()){
        var node = walker.currentNode;
        if (node.textContent.indexOf('ubcategory') !== -1 ||
            node.textContent.indexOf('ATV/UTV') !== -1){
          node.textContent = node.textContent
            .replace(/ATV\/UTV Subcategory Test/gi, newName)
            .replace(/ATV\/UTV Subcategory/gi, newName)
            .replace(/Subcategory Test/gi, newName);
        }
      }
    }
  }

  /* ---- Hide old UI elements ---- */
  function hideOldUI(){
    var ms = document.getElementById('a2d-ms');
    if (ms) ms.style.display = 'none';
    var bars = document.querySelectorAll('.a2d-submodel-bar, [class*="submodel-bar"]');
    bars.forEach(function(b){ b.style.display = 'none'; });
  }

  /* ============================================================
     A2D: PROGRESSIVE DISCLOSURE — 2026-05-10
     Hide non-brand filters until a brand is selected.
     Reorder brand values: Polaris, Can-Am, Yamaha, Honda first.
     ============================================================ */
  var BRAND_DISPLAY_ORDER = isSnowmobile?['Polaris','Ski-Doo','Arctic Cat','Lynx']:['Polaris','Can-Am','Yamaha','Honda'];

  function applyProgressiveDisclosure(){
    var isTW = isTiresWheelsCollection();
    var selectedBrands = getSelectedBrands();
    var accordions = document.querySelectorAll('accordion-custom.facets__item');
    var brandSeen = false;
    var lastBrandAcc = null;

    if (isTW){
      /* ---- TIRES & WHEELS: No progressive disclosure ---- */
      accordions.forEach(function(acc){
        var details = acc.querySelector('details');
        if (!details) return;
        var rect = acc.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return;

        var type = identifyGroup(details);
        if (type === 'brand'){
          /* Hide Machine Brand — we show a custom Brand filter instead */
          acc.classList.add('a2d-filter-hidden');
        } else if (type === 'model_family' || type === 'submodel' || type === 'year'){
          /* Hide fitment filters — not relevant for tires/wheels */
          acc.classList.add('a2d-filter-hidden');
        } else {
          /* Show Parts Filter (subcategory), category, and others */
          acc.classList.remove('a2d-filter-hidden');
        }
      });

      /* Remove progressive disclosure hint if present */
      var existingHint = document.querySelector('.a2d-brand-hint');
      if (existingHint) existingHint.remove();

      /* Build custom Brand filter for T&W */
      buildTireWheelBrandFilter();
      return;
    }

    /* ---- STANDARD COLLECTIONS: Progressive disclosure ---- */
    accordions.forEach(function(acc){
      var details = acc.querySelector('details');
      if (!details) return;
      var rect = acc.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return;

      var type = identifyGroup(details);
      if (type === 'brand'){
        if (!brandSeen){
          acc.classList.remove('a2d-filter-hidden');
          lastBrandAcc = acc;
          brandSeen = true;
        } else {
          acc.classList.add('a2d-filter-hidden');
        }
      } else if (selectedBrands.length === 0){
        acc.classList.add('a2d-filter-hidden');
      } else {
        acc.classList.remove('a2d-filter-hidden');
      }
    });

    var existingHint = document.querySelector('.a2d-brand-hint');
    if (selectedBrands.length === 0){
      if (!existingHint && lastBrandAcc){
        var hint = document.createElement('div');
        hint.className = 'a2d-brand-hint';
        hint.textContent = '— select a brand to see more filters —';
        lastBrandAcc.after(hint);
      }
    } else {
      if (existingHint) existingHint.remove();
    }
  }

  function expandAllShowMore(){
    document.querySelectorAll('accordion-custom.facets__item').forEach(function(acc){
      var details=acc.querySelector('details');if(!details)return;
      var kind=identifyGroup(details);
      if(kind!=='brand'&&kind!=='model_family'&&kind!=='submodel')return;
      acc.querySelectorAll('.facets__inputs-list-item.hidden').forEach(function(li){li.classList.remove('hidden');});
      acc.querySelectorAll('show-more button,.show-more__button').forEach(function(btn){btn.hidden=true;});
    });
  }

  function reorderBrands(){
    var accordions = document.querySelectorAll('accordion-custom.facets__item');
    accordions.forEach(function(acc){
      var details = acc.querySelector('details');
      if (!details) return;
      if (identifyGroup(details) !== 'brand') return;

      var list = details.querySelector('ul');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
      if (items.length === 0) return;

      var ordered = [];
      var rest = [];

      BRAND_DISPLAY_ORDER.forEach(function(brand){
        for (var i = 0; i < items.length; i++){
          var text = getFilterText(items[i]);
          if (text && text.toLowerCase() === brand.toLowerCase()){
            ordered.push(items[i]);
            break;
          }
        }
      });

      items.forEach(function(li){
        if (ordered.indexOf(li) === -1) rest.push(li);
      });

      ordered.concat(rest).forEach(function(li){
        list.appendChild(li);
      });
    });
  }

  /* ============================================================
     TIRES & WHEELS: CUSTOM BRAND FILTER
     Creates a styled accordion with checkboxes for each brand.
     Uses filter.p.vendor URL param for native Shopify filtering.
     ============================================================ */
  function buildTireWheelBrandFilter(){
    /* Don't duplicate — check if already injected */
    if (document.getElementById('a2d-tw-brand-filter')) return;

    /* Find the SIDEBAR facets container (not the horizontal bar) */
    var facetsContainer = document.querySelector('.facets__filters-wrapper');
    if (!facetsContainer){
      /* Fallback: use the parent of the first sidebar accordion */
      var sidebarAccs = document.querySelectorAll('accordion-custom.facets__item');
      for (var i = 0; i < sidebarAccs.length; i++){
        var r = sidebarAccs[i].getBoundingClientRect();
        if (r.x < 300 && r.width > 0){ facetsContainer = sidebarAccs[i].parentNode; break; }
      }
    }
    if (!facetsContainer) return;

    /* Get currently selected vendors from URL */
    var selectedVendors = getSelectedVendors();
    var selectedVendorsLower = selectedVendors.map(function(v){ return v.toLowerCase(); });

    /* Build the accordion HTML matching theme style */
    var acc = document.createElement('accordion-custom');
    acc.className = 'facets__item';
    acc.id = 'a2d-tw-brand-filter';

    var details = document.createElement('details');
    details.open = true;
    var summary = document.createElement('summary');
    summary.className = 'facets__summary';
    summary.innerHTML = '<span class="facets__heading-text">Brand</span>' +
      '<svg class="icon icon-chevron" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:12px;height:8px;margin-left:auto;">' +
      '<path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var ul = document.createElement('ul');
    ul.className = 'facets__list';
    ul.style.listStyle = 'none';
    ul.style.padding = '0';
    ul.style.margin = '0';

    TIRE_WHEEL_BRANDS.forEach(function(brand){
      var li = document.createElement('li');
      li.style.padding = '4px 0';

      var label = document.createElement('label');
      label.style.display = 'flex';
      label.style.alignItems = 'center';
      label.style.gap = '8px';
      label.style.cursor = 'pointer';
      label.style.fontSize = '13px';

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = 'a2d-tw-brand-cb';
      cb.setAttribute('data-brand', brand);
      cb.style.accentColor = '#e53e3e';

      /* Check if this brand is currently selected */
      if (selectedVendorsLower.indexOf(brand.toLowerCase()) !== -1){
        cb.checked = true;
      }

      /* Click handler — toggle vendor filter in URL */
      cb.addEventListener('change', function(){
        var url = new URL(window.location.href);
        var params = url.searchParams;
        /* Remove all existing vendor params */
        params.delete('filter.p.vendor');
        /* Re-add checked vendors */
        var allCbs = document.querySelectorAll('.a2d-tw-brand-cb');
        allCbs.forEach(function(c){
          if (c.checked){
            params.append('filter.p.vendor', c.getAttribute('data-brand'));
          }
        });
        /* Reset to page 1 */
        params.delete('page');
        window.location.href = url.toString();
      });

      var span = document.createElement('span');
      span.textContent = brand;

      label.appendChild(cb);
      label.appendChild(span);
      li.appendChild(label);
      ul.appendChild(li);
    });

    details.appendChild(summary);
    details.appendChild(ul);
    acc.appendChild(details);

    /* Insert at the top of the sidebar */
    var firstChild = facetsContainer.querySelector('accordion-custom.facets__item');
    if (firstChild){
      facetsContainer.insertBefore(acc, firstChild);
    } else {
      facetsContainer.appendChild(acc);
    }
  }

  /* ============================================================
     SORT DEFAULT — Set price-descending on T&W if no sort set
     ============================================================ */
  function applySortDefault(){
    if (!isTiresWheelsCollection()) return;
    var params = new URLSearchParams(window.location.search);
    if (!params.has('sort_by')){
      /* Set sort_by in URL without full page reload if possible */
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', 'price-descending');
      /* Use replaceState to avoid back-button loop, then reload */
      history.replaceState(null, '', url.toString());
      window.location.reload();
    }
  }

  /* ============================================================
     INITIALIZATION + OBSERVERS
     ============================================================ */

  /* ============================================================
     A2D P1/P2: ACTIVE FILTER BADGES — 2026-05-14
     Renders selected filter values as removable chips above
     the product grid. Clicking a chip removes that filter
     from the URL and reloads. "Clear all" removes all filters.
     ============================================================ */
  var FILTER_LABELS = {
    'filter.p.m.fitment.machine_brand': 'Brand',
    'filter.p.m.fitment.machine_model_family': 'Model',
    'filter.p.m.fitment.machine_submodel': 'Submodel',
    'filter.p.m.fitment.year_range': 'Year',
    'filter.p.m.fitment.atv_utv_subcategory_test': 'Parts',
    'filter.p.m.fitment.atv_utv_category': 'Category',
    'filter.p.vendor': 'Brand',
    'filter.p.tag': 'Tag'
  };

  function buildFilterBadges(){
    var params = new URLSearchParams(window.location.search);
    var container = document.getElementById('a2d-active-filters');

    /* Create container if it doesn't exist */
    if (!container){
      container = document.createElement('div');
      container.id = 'a2d-active-filters';
      container.className = 'a2d-active-filters';
      /* Insert above the product grid, after the filters block */
      var grid = document.querySelector('.product-grid-container .collection-wrapper');
      if (grid){
        var productGrid = grid.querySelector('.product-grid') || grid.querySelector('paginated-list');
        if (productGrid){
          productGrid.parentNode.insertBefore(container, productGrid);
        } else {
          grid.appendChild(container);
        }
      }
    }
    if (!container) return;

    /* Avoid rebuilding the same chips on their own DOM mutation. */
    if (container.dataset.a2dQuery === window.location.search) return;
    container.dataset.a2dQuery = window.location.search;
    container.innerHTML = '';

    /* Collect all active filter params */
    var activeFilters = [];
    params.forEach(function(value, key){
      if (key.startsWith('filter.')){
        activeFilters.push({ key: key, value: value });
      }
    });

    if (activeFilters.length === 0) return;

    /* Build chips */
    activeFilters.forEach(function(f){
      var label = FILTER_LABELS[f.key] || f.key.split('.').pop().replace(/_/g, ' ');
      var chip = document.createElement('a');
      chip.className = 'a2d-filter-chip';
      chip.title = 'Remove ' + label + ': ' + f.value;

      /* Build URL without this specific filter value */
      var url = new URL(window.location.href);
      var newParams = new URLSearchParams();
      url.searchParams.forEach(function(v, k){
        if (!(k === f.key && v === f.value)){
          newParams.append(k, v);
        }
      });
      /* Also remove dependent filters when removing a parent */
      if (f.key === 'filter.p.m.fitment.machine_brand'){
        newParams.delete('filter.p.m.fitment.machine_model_family');
        newParams.delete('filter.p.m.fitment.machine_submodel');
      } else if (f.key === 'filter.p.m.fitment.machine_model_family'){
        newParams.delete('filter.p.m.fitment.machine_submodel');
      }
      newParams.delete('page');
      url.search = newParams.toString();
      chip.href = url.toString();

      chip.textContent = label + ': ' + f.value + ' ×';
      container.appendChild(chip);
    });

    /* Clear all button if 2+ filters */
    if (activeFilters.length >= 1){
      var clearChip = document.createElement('a');
      clearChip.className = 'a2d-filter-chip a2d-filter-chip--clear';
      var clearUrl = new URL(window.location.href);
      var clearParams = new URLSearchParams();
      clearUrl.searchParams.forEach(function(v, k){
        if (!k.startsWith('filter.')) clearParams.append(k, v);
      });
      clearParams.delete('page');
      clearUrl.search = clearParams.toString();
      clearChip.href = clearUrl.toString();
      clearChip.textContent = 'Clear all';
      container.appendChild(clearChip);
    }
  }

  function init(){
    applySortDefault();
    ensureSubmodels(); curateAllFilters();
    buildFilterBadges();
    expandAllShowMore();
    reorderBrands();
    applyProgressiveDisclosure();
    hideOldUI();

    /* MutationObserver for AJAX filter reloads */
    var target = document.querySelector(
      '.collection-wrapper, results-list, .facets-container'
    );
    if (target){
      var debounce = null;
      var observer = new MutationObserver(function(mutations){
        var dominated = false;
        for (var i = 0; i < mutations.length; i++){
          if (mutations[i].addedNodes.length > 0){ dominated = true; break; }
        }
        if (dominated){
          clearTimeout(debounce);
          debounce = setTimeout(function(){
            ensureSubmodels(); curateAllFilters();
            expandAllShowMore();
            reorderBrands();
            applyProgressiveDisclosure();
            hideOldUI();
            buildFilterBadges();
          }, 60);
        }
      });
      observer.observe(target, { childList: true, subtree: true });
    }

    /* Watch for URL changes (history pushState/replaceState) */
    var origPush = history.pushState;
    history.pushState = function(){
      origPush.apply(this, arguments);
      setTimeout(function(){ ensureSubmodels(); curateAllFilters(); expandAllShowMore(); reorderBrands(); applyProgressiveDisclosure(); hideOldUI(); buildFilterBadges(); }, 120);
    };
    var origReplace = history.replaceState;
    history.replaceState = function(){
      origReplace.apply(this, arguments);
      setTimeout(function(){ ensureSubmodels(); curateAllFilters(); expandAllShowMore(); reorderBrands(); applyProgressiveDisclosure(); hideOldUI(); buildFilterBadges(); }, 120);
    };
    window.addEventListener('popstate', function(){
      setTimeout(function(){ ensureSubmodels(); curateAllFilters(); expandAllShowMore(); reorderBrands(); applyProgressiveDisclosure(); hideOldUI(); buildFilterBadges(); }, 120);
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
